import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { qualificationsNaming } from "../../api/typesDc";

export const QualificationList = (props:any) => {
  const { role } = props;
  const staffList = useSelector((state:any) => state.dataCaptures.staffDetails);
  const [t] = useTranslation();

  const users = staffList && staffList.length > 0 ? staffList?.filter((el:any) => el.leadershipRole.some((ell:any) => ell === role)) : [];
  
  let qualifications: any = [];
  
  users.forEach((el:any) => {
  el.qualifications.forEach((q:any) => {
    if (!qualifications.includes(q)) {
      qualifications.push(q);
    }
  })});

  const finalReturn = qualifications.map((el:any) => t(qualificationsNaming[el])).filter((label:any) => label != null && label != '').join(', ');
  
  return (<span>{t(finalReturn)}</span>);
}